import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../components/mensajes';
import { Table } from 'semantic-ui-react';
import { hex_md5 } from '../util/Md5';
import axios from 'axios';
import { Loader, Dimmer } from 'semantic-ui-react';



export const MensajeOlvidarClave = (props) => {

    /*  variables de estados */

    const btnCancela = useRef();
    const btnEnviar = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [password, setPassword] = useState('');
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({ txtEmail: '', passwd: '', txtCedula: '' });

    let op = require('../../public/modulos/datos');



    /* metodo para restablecer los valores  a su estado inicial */

    const blanquear = () => {
        setPassword('');
        setActivate(false);
        setValues({ txtEmail: '', passwd: '', txtCedula: '' })
    }

    /*  metodo para modificar la variable de estado values  */

    const onChange = (event) => {
        setValues({ ...values, [event.target.name]: event.target.value });

    };

    const handleInputChange = (event) => {
        if (event.which === 13) {
            if (event.target.name === 'txtCedula') {
                btnEnviar.current.focus();
            }
        }
    }


    /* metodo para validar que el email este registrado */

    const validarUsuario = () => {

        let endpoint = `${op.conexion}/api/athos/auth/forgotpassword?cedula=${values.txtCedula}`;

        axios.get(endpoint).then(function (response) {

            if (response.status == 200) {
                if (response.data !== '') {
                    setValues({ ...values, txtEmail: response.data.email, passwd: pass2 });
                    setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta seguro de recuperar la clave?', icono: 'confirmacion' });
                } else {
                    setMensaje({ mostrar: true, titulo: 'Error', texto: 'no tiene un correo registrado o no existe un usuario con esta cedula.', icono: 'error' });
                }
            }

        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        });
    }


    /*  metodo para actualizar la contraseña */

    const datosUsuario = () => {

        let body = {
            cedula: values.txtCedula,
            passwd: hex_md5(password)
        }

        let endpoint = `${op.conexion}/api/athos/auth/recoverpassword`;
        axios.post(endpoint, body).then(function (response) {

            if (response.status == 200) {

                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'su contraseña fue enviada al ' + values.txtEmail, icono: 'exito' });
                blanquear();

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        });
    }


    /*  metodo para enviar la contraseña al email */

    const onEnviar = (event) => {
        if (values.txtCedula === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Introduzca una cedula Valida.', icono: 'informacion' });
        } else {
            validarUsuario();
        }
    };


    /* metodo para confirmar la recuperacion */

    const handleCloseSi = () => {

        setMensajesino({ mostrar: false, titulo: 'Confirmación.', texto: '', icono: 'confirmacion' });

        setActivate(true);

        let endpoint = op.email + "/send-email";
        axios.post(endpoint, {
            email: values.txtEmail,
            name: values.txtEmail,
            passwd: password,
            message: ''
        }).then(function (response) {
            if (response.status == 200) {
                datosUsuario();
            } else if (response.status == 204) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'correo no encontrado', icono: 'informacion' });
            }


        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Error interno de Conexión.', icono: 'informacion' });

        }).then(function () {
            setActivate(false);
        });


    };


    /*  metodo para generar la nueva contraseña */

    const generar = (longitud) => {
        var long = parseInt(longitud);
        var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
        var contraseña = "";
        for (var i = 0; i < long; i++) contraseña += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        return contraseña;
    };

    useEffect(() => {
        setPassword(generar(6).toString());
    }, []);

    var pass2 = hex_md5(password);

    const cancelar = () => {
        blanquear();
        props.onHide();
    }

    const cerrarModal = () => {
        props.onHide();
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { btnCancela.current.focus() }}
        >
            <Modal.Header className='azulGradiant2'>
                <Modal.Title style={{ color: "#fff" }}>Recuperar Contraseña.</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body className='amanecergris'>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>cargando...</Loader>
                </Dimmer>
                <div>

                    <Table style={{ backgroundColor: 'transparent', border: 'none' }} >

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell align="center" >
                                    <div id="wizard" className="swMain" style={{ padding: 10 }}>

                                        <div className="stepContainer">

                                            <div id="step-1">
                                                <h2 className="StepTitle" style={{ textAlign: "center" }}> Ingrese la Cedula del Usuario</h2>
                                                <table className='col-12' align="center">
                                                    <tbody>
                                                        <tr align="center">
                                                            <td>
                                                                <input name="txtCedula" autoComplete="off" value={values.txtCedula} onKeyUp={handleInputChange} onChange={onChange} type="text" placeholder="1234567890" className="form-control col-md-10" id="txtCedula" /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm  btn-success" ref={btnEnviar} style={{ color: "#fff", border: "none" }} onClick={onEnviar}>
                    <i className='fas fa-check-circle'> Aceptar</i>
                </button>

                <button ref={btnCancela} onClick={cancelar} className='btn btn-sm btn-secondary'>
                    <i className='fas fa-window-close'> Cancelar</i>
                </button>

            </Modal.Footer>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/pages/recuperarClave.js